<template>
    <div class="food">
        <img src="@/assets/img/secondLevelPage/mingcaiBg.jpg" class="mingcaiBg hml_whplt">
        <ul class="topNav">
            <div>
                <li
                v-for="(item,index) in foodList"
                :key="index"
                :class="{active: topNavActive == index}"
                @click="topNavClick(index)"
                >
                    {{ item.title }}
                    <div class="bg" v-if="index == 0"></div>
                </li>
            </div>
        </ul>
        <mingcai v-if="topNavActive == 0" :list="foodList[0].list" @sildeClick="sildeClick"></mingcai>
        <mingtang v-if="topNavActive == 1" :list="foodList[1].list" @sildeClick="sildeClick"></mingtang>
        <mingxi v-if="topNavActive == 2" :list="foodList[2].list" @sildeClick="sildeClick"></mingxi>
        <mingdian v-if="topNavActive == 3" :list="foodList[3].list" @sildeClick="sildeClick"></mingdian>

    </div>
</template>

<script>
import mingcai from "@/components/food/mingcai";
import mingtang from "@/components/food/mingtang";
import mingxi from "@/components/food/mingxi";
import mingdian from "@/components/food/mingdian";
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            topNavActive: 0,
            foodList: [
                {
                    title: "京山名菜",
                    type: 0,
                    list: [],
                },
                {
                    title: "京山名汤",
                    type: 1,
                    list: [],
                },
                {
                    title: "京山名席",
                    type: 2,
                    list: [],
                },
                {
                    title: "京山名店",
                    type: 3,
                    list: [],
                }
            ],
        }
    },
    created(){
        let array = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list;
        array.forEach((item,index) => {
            item.food_id = parseInt(item.food_id)
            let type1 = parseInt(item.typeOption);
            for(let i = 0; i < this.foodList.length; i++){
                if(this.foodList[i].type == type1){
                    this.foodList[i].list.push(item);
                }
            }
        });
        // console.log(array);
        if(this.foodState){
            this.setfoodState(false);
            let type = parseInt(array[this.levelThreeIndex].typeOption);
            for(let i = 0; i < this.foodList.length; i++){
                if(this.foodList[i].type == type){
                    this.topNavActive = i;
                }
            }
            
        }
        
    },
    methods: {
        sildeClick(item,flag=0){
            // console.log(item,flag);
            let array = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list;
            for(let i = 0; i < array.length; i++){
                if(array[i].title == item.title){
                    this.setIndex({levelThreeIndex: i});
                    break;
                }
            }
            this.setfoodState(true);
            flag?this.$router.push("/millenniumDetails"):this.$router.push("/foodDetails");
            
        },
        topNavClick(index){
            this.setSwiperNum(0);
            this.topNavActive = index;
            
        },
        ...publicData.mapMutations(["setIndex","setfoodState","setSwiperNum"])
    },
    components: {
        mingcai,
        mingtang,
        mingxi,
        mingdian
    },
    computed: {
        ...publicData.mapState(["levelThreeIndex","secondLevelIndex","firstLevelIndex","allData","staticeData","foodState"]),
    }
}
</script>

<style lang="scss" scoped>
.food{
    .topNav{
        width: 100%;
        height: 2.14rem;
        // padding-top: 1.2rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        padding: 1.2rem .4rem .3rem;
        z-index: 10;
        background:linear-gradient(0deg,rgba(93,197,174,.2) 0%,rgba(112,219,202,.2) 100%);
        background: url(../../../assets/img/secondLevelPage/foodTopNavBg.jpg) no-repeat;
        background-size: 100% 100%;
        div{
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: .32rem;
            background:linear-gradient(0deg,rgba(93,197,174,.2) 0%,rgba(112,219,202,.2) 100%);
        }
        li{
            width: 1.6rem;
            height: 100%;
            border-radius: .32rem;
            font-size: .28rem;
            color: #666;
            line-height: .64rem;
            text-align: center;
            transition: all .2s ease;
            &.active{
                background: #5DC4AE;
                color: #fff;
            }
        }
    }
    .foodSlide{
        width: 100%;
        height: 2.3rem;
        background: #fff;
        border-radius: .2rem;
        display: flex;
        justify-content: space-between;
        box-shadow:0px .11rem .4rem 0px rgba(41,41,41,0.25);
        position: relative;
        margin-top: .88rem;
        .img{
            width: 2.5rem;
            height: 2.5rem;
            margin-top: -.5rem;
        }
        .textBox{
            .titleBox{
                width: 4rem;
                height: .7rem;
                position: relative;
                margin-top: .24rem;
                span{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 3.66rem;
                    height: .48rem;
                    background:rgba(100,205,184,.2);
                    border-bottom-left-radius: .44rem;
                    font-size: .22rem;
                    color: #4EC0AC;
                    // margin-top: .24rem;
                    text-indent: .22rem;
                    line-height: .48rem;
                }
                h2{
                    width: 2.69rem;
                    height: .68rem;
                    background:linear-gradient(0deg,rgba(65,192,162,1) 0%,rgba(15,164,130,1) 100%);
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    font-size: .32rem;
                    color: #fff;
                    border-bottom-left-radius: .5rem;
                }
            }
        }
        p{
            color: #666;
            font-size: .22rem;
            margin-top: .18rem;
            line-height: .36rem;
            width: 3.55rem;
        }
    }
}
</style>